import premissions from './premissions'

export default {
    premissions
}